import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error:", location.pathname);
    // Add noindex meta tag
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow");
    document.head.appendChild(meta);
    return () => { meta.remove(); };
  }, [location.pathname]);

  return (
    <Layout hideBreadcrumbs>
      <section className="py-20 lg:py-32">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-bold text-foreground mb-4">404</h1>
          <p className="text-xl text-muted-foreground mb-8">Strona nie została znaleziona</p>
          <a href="/" className="gradient-gold text-accent-foreground font-bold px-8 py-4 rounded-lg inline-block hover:opacity-90 transition-opacity shadow-gold">
            Wróć na stronę główną
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
